import React from 'react';
import { motion } from 'framer-motion';
export function TopBanner() {
  const items = ['⚠️ Oferta por tiempo limitado', '🔒 Pago 100% seguro MercadoPago', '📩 Acceso inmediato por mail', '💳 3 cuotas sin interés', '🎁 50% OFF — Precio de lanzamiento'];
  const duplicated = [...items, ...items, ...items, ...items];
  return <div className="w-full bg-amber-500 overflow-hidden py-2.5" data-id="element-230">
      <motion.div className="flex whitespace-nowrap gap-8" animate={{
      x: ['0%', '-50%']
    }} transition={{
      x: {
        repeat: Infinity,
        repeatType: 'loop',
        duration: 12,
        ease: 'linear'
      }
    }} data-id="element-231">
        {duplicated.map((item, index) => <span key={index} className="text-neutral-950 font-bold text-sm md:text-base flex-shrink-0 px-4" data-id="element-232">
            {item}
          </span>)}
      </motion.div>
    </div>;
}